/* =========================================================
   Kardeş ürün geçişi — "Diğer Seçenekler" tıklanınca sayfa
   yenilenmeden ürün bölümü değişir (Section Rendering API).
   JS/fetch yoksa veya hata olursa normal link navigasyonu.
   ========================================================= */
(function () {
  "use strict";

  var SECTION_SELECTOR = "[data-product-section]";

  function getSection() {
    return document.querySelector(SECTION_SELECTOR);
  }

  function swapTo(url, pushHistory) {
    var root = getSection();
    if (!root) { window.location.href = url; return; }

    var sectionId = root.getAttribute("data-section-id");
    var fetchUrl = url.split("#")[0] + (url.indexOf("?") > -1 ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId);

    root.classList.add("is-swapping");
    fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var next = tmp.querySelector(SECTION_SELECTOR);
        if (!next) throw new Error("Bölüm bulunamadı");
        root.replaceWith(next);
        if (pushHistory) history.pushState({ bicicekSwap: true }, "", url);
        var title = next.getAttribute("data-page-title");
        if (title) document.title = title;
        document.dispatchEvent(new CustomEvent("product:section-replaced"));
        initAllTracks();
        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  /* Kaydırılacak içerik yoksa oklar hiç gösterilmiyor: az kardeş ürünü olan
     sayfalarda boşa yer kaplıyorlardı. Sınıf .variant-siblings__track üzerinde,
     görünürlük kararını CSS veriyor (bkz. base.css .is-scrollable). */
  function updateArrows(root, grid, prev, next) {
    var scrollable = grid.scrollWidth > grid.clientWidth + 2;
    root.classList.toggle("is-scrollable", scrollable);
    if (!prev || !next) return;
    prev.disabled = grid.scrollLeft <= 2;
    next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
  }

  function initArrows(root) {
    var grid = root.querySelector("[data-siblings-grid]");
    var prev = root.querySelector("[data-siblings-prev]");
    var next = root.querySelector("[data-siblings-next]");
    if (!grid || !prev || !next) return;
    var step = 200;
    var sync = function () { updateArrows(root, grid, prev, next); };
    sync();
    grid.addEventListener("scroll", sync, { passive: true });
    prev.addEventListener("click", function () { grid.scrollBy({ left: -step, behavior: "smooth" }); });
    next.addEventListener("click", function () { grid.scrollBy({ left: step, behavior: "smooth" }); });

    /* Genişlik değişince (döndürme, pencere boyu) yeniden karar ver. Görseller
       geç yüklendiğinde scrollWidth sonradan büyüyor; ResizeObserver onu da yakalar. */
    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(grid);
    } else {
      window.addEventListener("resize", sync);
    }
  }

  function initAllTracks() {
    document.querySelectorAll("[data-siblings-track]").forEach(initArrows);
  }

  initAllTracks();

  document.addEventListener("click", function (e) {
    var link = e.target.closest ? e.target.closest("[data-sibling-link]") : null;
    if (!link) return;
    if (link.hasAttribute("aria-current")) { e.preventDefault(); return; }
    if (!window.fetch || !window.history || !history.pushState) return;
    e.preventDefault();
    swapTo(link.href, true);
  });

  window.addEventListener("popstate", function () {
    /* Ürün sayfası içinde ileri/geri: bölümü URL'e göre tazele.
       Ürün dışına çıkışta fetch başarısız olur ve tam sayfa yüklenir. */
    if (getSection()) swapTo(window.location.href, false);
  });
})();
